import React from "react";
import Button from "react-bootstrap/Button";
import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";

function ArrayFieldTitle(_ref) {
  var TitleField = _ref.TitleField,
      idSchema = _ref.idSchema,
      title = _ref.title,
      required = _ref.required;

  if (!title) {
    return null;
  }

  var id = idSchema.$id + "__title";
  return /*#__PURE__*/React.createElement(TitleField, {
    id: id,
    title: title,
    required: required
  });
}

function ArrayFieldDescription(_ref2) {
  var DescriptionField = _ref2.DescriptionField,
      idSchema = _ref2.idSchema,
      description = _ref2.description;

  if (!description) {
    return null;
  }

  var id = idSchema.$id + "__description";
  return /*#__PURE__*/React.createElement(DescriptionField, {
    id: id,
    description: description
  });
}

function DefaultArrayItem(props) {
  var btnStyle = {
    flex: 1,
    paddingLeft: 6,
    paddingRight: 6,
    fontWeight: "bold"
  };
  return /*#__PURE__*/React.createElement("div", {
    key: props.key,
    className: props.className
  }, props.children, props.hasToolbar && /*#__PURE__*/React.createElement("div", {
    className: "array-item-toolbox"
  }, /*#__PURE__*/React.createElement("div", {
    className: "btn-group",
    style: {
      display: "flex",
      justifyContent: "space-around"
    }
  }, (props.hasMoveUp || props.hasMoveDown) && /*#__PURE__*/React.createElement(Button, {
    variant: "light",
    style: btnStyle,
    tabIndex: "-1",
    disabled: props.disabled || props.readonly || !props.hasMoveUp,
    onClick: props.onReorderClick(props.index, props.index - 1)
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-long-arrow-alt-up"
  })), (props.hasMoveUp || props.hasMoveDown) && /*#__PURE__*/React.createElement(Button, {
    variant: "light",
    style: btnStyle,
    tabIndex: "-1",
    disabled: props.disabled || props.readonly || !props.hasMoveDown,
    onClick: props.onReorderClick(props.index, props.index + 1)
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-long-arrow-alt-down"
  })), props.hasRemove && /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    style: btnStyle,
    tabIndex: "-1",
    disabled: props.disabled || props.readonly,
    onClick: props.onDropIndexClick(props.index)
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-times"
  })))));
}

function ArrayFieldTemplate(props) {
  return /*#__PURE__*/React.createElement("fieldset", {
    className: props.className,
    id: props.idSchema.$id
  }, /*#__PURE__*/React.createElement(ArrayFieldTitle, {
    key: "array-field-title-" + props.idSchema.$id,
    TitleField: props.TitleField,
    idSchema: props.idSchema,
    title: props.uiSchema["ui:title"] || props.title,
    required: props.required
  }), (props.uiSchema["ui:description"] || props.schema.description) && /*#__PURE__*/React.createElement(ArrayFieldDescription, {
    key: "array-field-description-" + props.idSchema.$id,
    DescriptionField: props.DescriptionField,
    idSchema: props.idSchema,
    description: props.uiSchema["ui:description"] || props.schema.description
  }), /*#__PURE__*/React.createElement("div", {
    className: "array-item-list",
    key: "array-item-list-" + props.idSchema.$id
  }, props.items && props.items.map(function (p) {
    return DefaultArrayItem(p);
  })), props.canAdd && /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("p", {
    className: "col array-item-add"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "btn-add",
    variant: "link",
    tabIndex: "0",
    onClick: props.onAddClick,
    disabled: props.disabled || props.readonly
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-plus"
  })))));
}

export default ArrayFieldTemplate;